import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement("path", { d: "M0 12a12 12 0 1024 0 12 12 0 00-24 0z", fill: "#086AA7" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9 14.635a2.9 2.9 0 102.9-2.9 2.9 2.9 0 112.9-2.9M11.9 4v1.933M11.9 17.535v1.933",
      stroke: "#fff",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
), r = o;
export {
  r as default
};
